// import React, { useState } from 'react';
// import { Dialog } from 'primereact/dialog';
// import { Divider } from 'primereact/divider';
// import { FaCarSide, FaStore, FaCalendarAlt, FaTag, FaIdCard } from 'react-icons/fa';
// import { MdLocationOn, MdLocalParking, MdPayment, MdMiscellaneousServices, MdOutlinePriceCheck } from 'react-icons/md';
// import { IoReceiptOutline } from 'react-icons/io5';
// import { FiExternalLink } from 'react-icons/fi';
// import { formatDate, formatDateUTC, formatTimeInTimezone } from 'pages/utils/formdatedynamics';

// const ActiveOrders = ({ Accpet, Complete, orderlocation, status, billingStatus, Refuse, data, promoCode,showMarkButton=true}) => {
//     const [visible, setVisible] = useState(false);
//     const generalSans = { fontFamily: "'General Sans', sans-serif !important" };
//     console.log('Order Data:', data);
//     const isExpired = data?.isExpired;
// const displayStatus =
//   status === "ongoing" && isExpired
//     ? "Expired (System)"
//     : status;
//     const getStatusColors = (s) => {
//         const lower = s?.toLowerCase();
//        if (lower === "expired (system)") return { bg: "#FEE2E2", text: "#DC2626" }; // red
//   if (lower === "ongoing") return { bg: "#EEF2FF", text: "#4338CA" };
//   if (lower === "inprocess") return { bg: "#FFFBEB", text: "#D97706" };
//         return { bg: '#ECFDF5', text: '#059669' };
//     };
//     const sStyle = getStatusColors(displayStatus);
//     const cost = parseFloat(data?.cost || 0);   
//     const serviceFeePercent = parseFloat(data?.serviceFee?.[0]?.WashtaFees || 0);
//     const serviceFeeAmount = (cost * (serviceFeePercent / 100)).toFixed(2);
//     // const finalPrice = data?.finalCost || (cost - serviceFeeAmount).toFixed(2);
// const finalPrice = Number(data?.finalCost ?? cost - serviceFeeAmount);
//     const dialogStyles = {
//         mask: { backgroundColor: 'rgba(0, 0, 0, 0.85)', backdropFilter: 'blur(10px)', zIndex: 1100 },
//         root: { backgroundColor: '#ffffff', borderRadius: '30px', width: '95vw', maxWidth: '480px', border: 'none', ...generalSans },
//         header: { backgroundColor: '#ffffff', padding: '25px 25px 0 25px', border: 'none' }
//     };

//     return (
//         <div style={{
//             background: '#ffffff', borderRadius: '26px', padding: '22px', marginBottom: '20px',
//             boxShadow: '0 12px 45px rgba(0,0,0,0.06)', border: '1px solid #f1f5f9', ...generalSans,
//             position: 'relative', overflow: 'hidden'
//         }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                     <div style={{ background: '#747EEF', borderRadius: '14px', display: 'flex', padding: '10px', color: 'white', boxShadow: '0 4px 10px rgba(116, 126, 239, 0.3)' }}>
//                         <FaStore size={18} />
//                     </div>
//                     <div>
//                         <span style={{ fontWeight: '800', fontSize: '17px', color: '#1e293b', display: 'block' }}>{data?.shopId?.shopName || "Shop"}</span>
//                         {/* <span style={{ fontSize: '11px', color: '#94a3b8', fontWeight: '600' }}>ID: #{data?._id?.slice(-5).toUpperCase()}</span> */}
//                     </div>
//                 </div>
//                 <div style={{ background: sStyle.bg, color: sStyle.text, padding: '6px 14px', borderRadius: '12px', fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.8px', border: `1px solid ${sStyle.text}20` }}>
//                     {displayStatus}
//                 </div>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f1f2fd', padding: '15px', borderRadius: '18px', marginBottom: '15px' }}>
//                 <div style={{ textAlign: 'left' }}>
//                     <span style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800', display: 'block' }}>Billing Status</span>
//                     <span style={{ fontSize: '18px', fontWeight: '900', color: '#10b981' }}>{billingStatus}</span>
//                 </div>
//                 <div style={{ textAlign: 'right' }}>
//                     <span style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800', display: 'block' }}>TOTAL PRICE</span>
//                     {/* <span style={{ fontSize: '18px', fontWeight: '900', color: '#10b981' }}>{Number(finalPrice).toFixed(2)} AED</span> */}
//                     <span style={{ fontSize: '18px', fontWeight: '900', color: '#10b981' }}>{data?.cost} AED</span>
//                 </div>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                     <FaCarSide color="#747EEF" size={18} />
//                     <span style={{ fontSize: '14px', fontWeight: '700', color: '#475569' }}>{data?.vehicleId?.vehicleManufacturer || "Car Name"} {data?.vehicleId?.vehicleName || "Car Name"}</span>
//                 </div>
//                 <div style={{ border: '2px solid #1e293b', background: '#fde047', color: '#1e293b', padding: '2px 10px', borderRadius: '6px', fontWeight: '900', fontSize: '12px', letterSpacing: '0.5px' }}>
//                     {data?.vehicleId?.vehiclePlateNumber || "DUBAI A 0000"}
//                 </div>
//             </div>
//             <div style={{ marginBottom: '20px' }}>
//                 <div style={{ display: 'flex', alignItems: 'start', gap: '8px', marginBottom: '10px' }}>
//                     <MdLocationOn size={18} color="#747EEF" style={{ marginTop: '2px' }} />
//                     <div>
//                         <span style={{ fontSize: '11px', fontWeight: '800', color: '#94a3b8', display: 'block', textTransform: 'uppercase' }}>Customer Location:</span>
//                         <span style={{ fontSize: '13px', color: '#475569', fontWeight: '600', lineHeight: '1.4' }}>{data?.location?.text || orderlocation}</span>
//                     </div>
//                 </div>
//                 <div style={{ background: 'linear-gradient(to right, #eff6ff, #ffffff)', padding: '14px', borderRadius: '16px', border: '1px solid #dbeafe', display: 'flex', alignItems: 'center', gap: '10px' }}>
//                     <MdLocalParking color="#3b82f6" size={24} />
//                     <div>
//                         <span style={{ fontSize: '10px', fontWeight: '800', color: '#3b82f6', display: 'block' }}>PARKED AT:</span>
//                         <span style={{ fontSize: '15px', fontWeight: '900', color: '#1e40af' }}>{data?.carParkedAt}</span>
//                     </div>
//                 </div>
//             </div>
//             <div style={{ display: 'flex', gap: '12px' }}>
//                 {/* {status === 'ongoing' ? (
//                     <>
//                         <button onClick={Refuse} style={{ flex: 1, padding: '14px', borderRadius: '16px', border: '1.5px solid #fee2e2', color: '#ef4444', background: '#fff', fontWeight: '600', cursor: 'pointer', ...generalSans }}>Refuse</button>
//                         <button onClick={Accpet} style={{ flex: 1, padding: '14px', borderRadius: '16px', border: 'none', color: 'white', background: '#747EEF', fontWeight: '600', cursor: 'pointer', boxShadow: '0 4px 15px rgba(116, 126, 239, 0.4)', ...generalSans }}>Accept</button>
//                     </>
//                 ) : (
                    
//                     <button onClick={Complete} style={{ flex: 1, padding: '15px', borderRadius: '16px', border: 'none', color: 'white', background: '#10b981', fontWeight: '600', cursor: 'pointer', width: '100%', boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)', ...generalSans }}>Mark Completed</button>
//                 )} */}
//                {status === "ongoing" && !isExpired ? (
//   <>
//     <button
//       onClick={Refuse}
//       style={{
//         flex: 1,
//         padding: '14px',
//         borderRadius: '16px',
//         border: '1.5px solid #fee2e2',
//         color: '#ef4444',
//         background: '#fff',
//         fontWeight: '600',
//         cursor: 'pointer',
//         ...generalSans
//       }}
//     >
//       Refuse
//     </button>

//     <button
//       onClick={Accpet}
//       style={{
//         flex: 1,
//         padding: '14px',
//         borderRadius: '16px',
//         border: 'none',
//         color: 'white',
//         background: '#747EEF',
//         fontWeight: '600',
//         cursor: 'pointer',
//         boxShadow: '0 4px 15px rgba(116, 126, 239, 0.4)',
//         ...generalSans
//       }}
//     >
//       Accept
//     </button>
//   </>
// ) : (
// showMarkButton && !isExpired && (
//     <button
//       onClick={Complete}
//       style={{
//         flex: 1,
//         padding: '15px',
//         borderRadius: '16px',
//         border: 'none',
//         color: 'white',
//         background: '#10b981',
//         fontWeight: '600',
//         cursor: 'pointer',
//         width: '100%',
//         boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)',
//         ...generalSans
//       }}
//     >
//       Mark Completed
//     </button>
//   )
// )}

//             </div>

//             <div style={{ textAlign: 'center', marginTop: '15px' }}>
//                 <span onClick={() => setVisible(true)} style={{ color: '#64748b', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '5px', textDecoration: 'underline' }}>
//                     <FiExternalLink /> View Detailed
//                 </span>
//             </div>
//             <Dialog 
//                 visible={visible} 
//                 onHide={() => setVisible(false)}
//                 header={<div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '22px', fontWeight: '900', ...generalSans }}><IoReceiptOutline color="#747EEF" /> Order Details</div>}
//                 style={dialogStyles.root}
//                 maskStyle={dialogStyles.mask}
//                 headerStyle={dialogStyles.header}
//                 modal={true}
//                 draggable={false}
//             >
//                 <div style={{ padding: '0 25px 25px 25px', background: '#fff', ...generalSans }}>
                    
//                     {/* Customer Profile Popup */}
//                     <div style={{ background: '#f1f2fd', padding: '20px', borderRadius: '24px', border: '1px solid #e2e8f0', marginBottom: '20px', textAlign: 'center' }}>
//                         <div style={{ background: '#fff', borderRadius: '50%', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#747EEF', margin: '0 auto 10px auto', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}><FaStore size={30} /></div>
//                         <span style={{ fontSize: '11px', color: '#94a3b8', fontWeight: '800', textTransform: 'uppercase' }}>Shop Name</span>
//                         <div style={{ fontSize: '20px', fontWeight: '900', color: '#1e293b' }}>{data?.shopId?.shopName || "Shop Name"}</div>
//                     </div>

//                     {/* Vehicle & Service Info */}
//                     <div style={{ marginBottom: '20px' }}>
//                         <h4 style={{ fontSize: '12px', color: '#747EEF', fontWeight: '800', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>VEHICLE & SERVICE</h4>
//                         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
//                             <div>
//                                 <label style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>MANUFACTURER</label>
//                                 <div style={{ fontSize: '14px', fontWeight: '700' }}>{data?.vehicleId?.vehicleManufacturer || "Manufacturer"}</div>
//                             </div>
//                             <div>
//                                 <label style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>MODEL NAME</label>
//                                 <div style={{ fontSize: '14px', fontWeight: '700' }}>{data?.vehicleId?.vehicleName || "Model Name"}</div>
//                             </div>
//                             <div>
//                                 <label style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>PLATE NUMBER</label>
//                                 <div style={{ border: '2px solid #1e293b', background: '#fde047', color: '#1e293b', padding: '2px 10px', borderRadius: '6px', fontWeight: '900', fontSize: '12px', display: 'inline-block', marginTop: '4px' }}>{data?.vehicleId?.vehiclePlateNumber || "DUBAI A 0000"}</div>
//                             </div>
//                             <div>
//                                 <label style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>SERVICE TYPE</label>
//                                 <div style={{ fontSize: '14px', fontWeight: '700', color: '#747EEF' }}>{data?.carServiceName || "Full Wash"}</div>
//                             </div>
//                         </div>
//                     </div>

//                     <Divider />

//                     {/* Full Location Info */}
//                     <div style={{ marginBottom: '20px' }}>
//                          <h4 style={{ fontSize: '12px', color: '#747EEF', fontWeight: '800', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>LOCATION DETAILS</h4>
//                          <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
//                             <MdLocationOn color="#94a3b8" size={20} />
//                             <span style={{ fontSize: '14px', color: '#475569', fontWeight: '600' }}>Customer Location: <span style={{fontWeight: '500'}}>{data?.location?.text || orderlocation}</span></span>
//                          </div>
//                          <div style={{ background: '#f0f9ff', padding: '15px', borderRadius: '16px', borderLeft: '6px solid #0ea5e9' }}>
//                             <span style={{ fontSize: '15px', fontWeight: '900', color: '#0369a1' }}>Parked At: {data?.carParkedAt}</span>
//                         </div>
//                     </div>

//                     <Divider />

//                     {/* BILLING SUMMARY (No VAT) */}
//                     <h4 style={{ fontSize: '12px', color: '#747EEF', fontWeight: '800', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>BILLING SUMMARY</h4>
//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px' }}>
//                             <span style={{ color: '#64748b' }}>Shop Price</span>
//                             <span style={{ fontWeight: '700' }}>{data?.cost} AED</span>
//                         </div>

//                         {/* <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px', color: '#ef4444' }}>
//                             <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><MdMiscellaneousServices /> Service Fee ({serviceFeePercent}%)</span>
//                             <span style={{ fontWeight: '700' }}>- {serviceFeeAmount} AED</span>
//                         </div> */}

//                         {(data?.discount > 0 || promoCode) && (
//                             <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px', color: '#10b981', background: '#f0fdf4', padding: '12px', borderRadius: '14px' }}>
//                                 <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaTag /> Promo Discount Applied</span>
//                                 <span style={{ fontWeight: '900' }}>- {Number(data?.discount).toFixed(2)}  AED</span>
//                             </div>
//                         )}

//                         <div style={{ borderTop: '2.5px solid #f1f5f9', marginTop: '10px', paddingTop: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <span style={{ fontWeight: '900', fontSize: '18px', color: '#1e293b' }}>Total Final Amount</span>
//                             {/* <span style={{ fontSize: '28px', fontWeight: '950', color: '#10b981' }}>{Number(finalPrice).toFixed(2)} AED</span> */}
//                             <span style={{ fontSize: '28px', fontWeight: '950', color: '#10b981' }}>{data?.cost} AED</span>
//                         </div>
//                     </div>

//                     {/* Footer Data */}
//                     <div style={{ marginTop: '25px', padding: '15px', background: '#1e293b', borderRadius: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#fff' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px' }}>
//                             <FaCalendarAlt opacity={0.6} />{formatDateUTC(data?.date) } : {formatTimeInTimezone(data?.time)}
//                         </div>
//                         <div style={{ fontSize: '12px', fontWeight: '900', textTransform: 'uppercase', color: '#10b981' }}>{billingStatus}</div>
//                     </div>

//                     <button 
//                         onClick={() => setVisible(false)}
//                         style={{ width: '100%', marginTop: '20px', padding: '16px', borderRadius: '18px', border: '1px solid #e2e8f0', background: '#fff', fontWeight: '900', color: '#1e293b', cursor: 'pointer', fontSize: '15px', ...generalSans }}
//                     >
//                         Close Details
//                     </button>
//                 </div>
//             </Dialog>
//         </div>
//     );
// };

// export default ActiveOrders;
import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { FaCarSide, FaStore, FaCalendarAlt, FaTag, FaIdCard } from 'react-icons/fa';
import { MdLocationOn, MdLocalParking, MdPayment, MdMiscellaneousServices, MdOutlinePriceCheck } from 'react-icons/md';
import { IoReceiptOutline } from 'react-icons/io5';
import { FiExternalLink } from 'react-icons/fi';
import { formatDate, formatDateUTC, formatTimeInTimezone } from 'pages/utils/formdatedynamics';
import CircularProgress from '@mui/material/CircularProgress'; // Added MUI Spinner

const ActiveOrders = ({ Accpet, Complete, orderlocation, status, billingStatus, Refuse, data, promoCode, showMarkButton = true }) => {
    const [visible, setVisible] = useState(false);
    // State to track which button is loading: 'accept', 'refuse', or 'complete'
    const [loadingAction, setLoadingAction] = useState(null);

    const generalSans = { fontFamily: "'General Sans', sans-serif !important" };
    
    const isExpired = data?.isExpired;
    const displayStatus = status === "ongoing" && isExpired ? "Expired (System)" : status;

    const getStatusColors = (s) => {
        const lower = s?.toLowerCase();
        if (lower === "expired (system)") return { bg: "#FEE2E2", text: "#DC2626" };
        if (lower === "ongoing") return { bg: "#EEF2FF", text: "#4338CA" };
        if (lower === "inprocess") return { bg: "#FFFBEB", text: "#D97706" };
        return { bg: '#ECFDF5', text: '#059669' };
    };

    const sStyle = getStatusColors(displayStatus);
    const cost = parseFloat(data?.cost || 0);
    const serviceFeePercent = parseFloat(data?.serviceFee?.[0]?.WashtaFees || 0);
    const serviceFeeAmount = (cost * (serviceFeePercent / 100)).toFixed(2);
    const finalPrice = Number(data?.finalCost ?? cost - serviceFeeAmount);

    // Wrapper function to handle API calls with loading state
    const handleAction = async (actionType, actionFn) => {
        setLoadingAction(actionType);
        try {
            await actionFn(); // Execute the passed API function
        } catch (error) {
            console.error("Action failed", error);
        } finally {
            setLoadingAction(null);
        }
    };

    const dialogStyles = {
        mask: { backgroundColor: 'rgba(0, 0, 0, 0.85)', backdropFilter: 'blur(10px)', zIndex: 1100 },
        root: { backgroundColor: '#ffffff', borderRadius: '30px', width: '95vw', maxWidth: '480px', border: 'none', ...generalSans },
        header: { backgroundColor: '#ffffff', padding: '25px 25px 0 25px', border: 'none' }
    };

    return (
        <div style={{
            background: '#ffffff', borderRadius: '26px', padding: '22px', marginBottom: '20px',
            boxShadow: '0 12px 45px rgba(0,0,0,0.06)', border: '1px solid #f1f5f9', ...generalSans,
            position: 'relative', overflow: 'hidden'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{ background: '#747EEF', borderRadius: '14px', display: 'flex', padding: '10px', color: 'white', boxShadow: '0 4px 10px rgba(116, 126, 239, 0.3)' }}>
                        <FaStore size={18} />
                    </div>
                    <div>
                        <span style={{ fontWeight: '800', fontSize: '17px', color: '#1e293b', display: 'block' }}>{data?.shopId?.shopName || "Shop"}</span>
                    </div>
                </div>
                <div style={{ background: sStyle.bg, color: sStyle.text, padding: '6px 14px', borderRadius: '12px', fontSize: '11px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.8px', border: `1px solid ${sStyle.text}20` }}>
                    {displayStatus}
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f1f2fd', padding: '15px', borderRadius: '18px', marginBottom: '15px' }}>
                <div style={{ textAlign: 'left' }}>
                    <span style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800', display: 'block' }}>Billing Status</span>
                    <span style={{ fontSize: '18px', fontWeight: '900', color: '#10b981' }}>{billingStatus}</span>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <span style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800', display: 'block' }}>TOTAL PRICE</span>
                    <span style={{ fontSize: '18px', fontWeight: '900', color: '#10b981' }}>{data?.cost} AED</span>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FaCarSide color="#747EEF" size={18} />
                    <span style={{ fontSize: '14px', fontWeight: '700', color: '#475569' }}>{data?.vehicleId?.vehicleManufacturer || "Car Name"} {data?.vehicleId?.vehicleName || "Car Name"}</span>
                </div>
                <div style={{ border: '2px solid #1e293b', background: '#fde047', color: '#1e293b', padding: '2px 10px', borderRadius: '6px', fontWeight: '900', fontSize: '12px', letterSpacing: '0.5px' }}>
                    {data?.vehicleId?.vehiclePlateNumber || "DUBAI A 0000"}
                </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'start', gap: '8px', marginBottom: '10px' }}>
                    <MdLocationOn size={18} color="#747EEF" style={{ marginTop: '2px' }} />
                    <div>
                        <span style={{ fontSize: '11px', fontWeight: '800', color: '#94a3b8', display: 'block', textTransform: 'uppercase' }}>Customer Location:</span>
                        <span style={{ fontSize: '13px', color: '#475569', fontWeight: '600', lineHeight: '1.4' }}>{data?.location?.text || orderlocation}</span>
                    </div>
                </div>
                <div style={{ background: 'linear-gradient(to right, #eff6ff, #ffffff)', padding: '14px', borderRadius: '16px', border: '1px solid #dbeafe', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <MdLocalParking color="#3b82f6" size={24} />
                    <div>
                        <span style={{ fontSize: '10px', fontWeight: '800', color: '#3b82f6', display: 'block' }}>PARKED AT:</span>
                        <span style={{ fontSize: '15px', fontWeight: '900', color: '#1e40af' }}>{data?.carParkedAt}</span>
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
                {status === "ongoing" && !isExpired ? (
                    <>
                        <button
                            onClick={() => handleAction('refuse', Refuse)}
                            disabled={loadingAction !== null}
                            style={{
                                flex: 1, padding: '14px', borderRadius: '16px', border: '1.5px solid #fee2e2',
                                color: '#ef4444', background: '#fff', fontWeight: '600', cursor: loadingAction ? 'not-allowed' : 'pointer', ...generalSans
                            }}
                        >
                            {loadingAction === 'refuse' ? <CircularProgress size={20} color="inherit" /> : 'Refuse'}
                        </button>

                        <button
                            onClick={() => handleAction('accept', Accpet)}
                            disabled={loadingAction !== null}
                            style={{
                                flex: 1, padding: '14px', borderRadius: '16px', border: 'none', color: 'white',
                                background: '#747EEF', fontWeight: '600', cursor: loadingAction ? 'not-allowed' : 'pointer',
                                boxShadow: '0 4px 15px rgba(116, 126, 239, 0.4)', ...generalSans
                            }}
                        >
                            {loadingAction === 'accept' ? <CircularProgress size={20} color="inherit" /> : 'Accept'}
                        </button>
                    </>
                ) : (
                    showMarkButton && !isExpired && (
                        <button
                            onClick={() => handleAction('complete', Complete)}
                            disabled={loadingAction !== null}
                            style={{
                                flex: 1, padding: '15px', borderRadius: '16px', border: 'none', color: 'white',
                                background: '#10b981', fontWeight: '600', cursor: loadingAction ? 'not-allowed' : 'pointer', width: '100%',
                                boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)', ...generalSans
                            }}
                        >
                            {loadingAction === 'complete' ? <CircularProgress size={20} color="inherit" /> : 'Mark Completed'}
                        </button>
                    )
                )}
            </div>

            <div style={{ textAlign: 'center', marginTop: '15px' }}>
                <span onClick={() => setVisible(true)} style={{ color: '#64748b', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '5px', textDecoration: 'underline' }}>
                    <FiExternalLink /> View Detailed
                </span>
            </div>

            <Dialog
                visible={visible}
                onHide={() => setVisible(false)}
                header={<div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '22px', fontWeight: '900', ...generalSans }}><IoReceiptOutline color="#747EEF" /> Order Details</div>}
                style={dialogStyles.root}
                maskStyle={dialogStyles.mask}
                headerStyle={dialogStyles.header}
                modal={true}
                draggable={false}
            >
                <div style={{ padding: '0 25px 25px 25px', background: '#fff', ...generalSans }}>
                    <div style={{ background: '#f1f2fd', padding: '20px', borderRadius: '24px', border: '1px solid #e2e8f0', marginBottom: '20px', textAlign: 'center' }}>
                        <div style={{ background: '#fff', borderRadius: '50%', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#747EEF', margin: '0 auto 10px auto', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}><FaStore size={30} /></div>
                        <span style={{ fontSize: '11px', color: '#94a3b8', fontWeight: '800', textTransform: 'uppercase' }}>Shop Name</span>
                        <div style={{ fontSize: '20px', fontWeight: '900', color: '#1e293b' }}>{data?.shopId?.shopName || "Shop Name"}</div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <h4 style={{ fontSize: '12px', color: '#747EEF', fontWeight: '800', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>VEHICLE & SERVICE</h4>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                            <div>
                                <label style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>MANUFACTURER</label>
                                <div style={{ fontSize: '14px', fontWeight: '700' }}>{data?.vehicleId?.vehicleManufacturer || "Manufacturer"}</div>
                            </div>
                            <div>
                                <label style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>MODEL NAME</label>
                                <div style={{ fontSize: '14px', fontWeight: '700' }}>{data?.vehicleId?.vehicleName || "Model Name"}</div>
                            </div>
                            <div>
                                <label style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>PLATE NUMBER</label>
                                <div style={{ border: '2px solid #1e293b', background: '#fde047', color: '#1e293b', padding: '2px 10px', borderRadius: '6px', fontWeight: '900', fontSize: '12px', display: 'inline-block', marginTop: '4px' }}>{data?.vehicleId?.vehiclePlateNumber || "DUBAI A 0000"}</div>
                            </div>
                            <div>
                                <label style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>SERVICE TYPE</label>
                                <div style={{ fontSize: '14px', fontWeight: '700', color: '#747EEF' }}>{data?.carServiceName || "Full Wash"}</div>
                            </div>
                        </div>
                    </div>

                    <Divider />

                    <div style={{ marginBottom: '20px' }}>
                        <h4 style={{ fontSize: '12px', color: '#747EEF', fontWeight: '800', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>LOCATION DETAILS</h4>
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                            <MdLocationOn color="#94a3b8" size={20} />
                            <span style={{ fontSize: '14px', color: '#475569', fontWeight: '600' }}>Customer Location: <span style={{ fontWeight: '500' }}>{data?.location?.text || orderlocation}</span></span>
                        </div>
                        <div style={{ background: '#f0f9ff', padding: '15px', borderRadius: '16px', borderLeft: '6px solid #0ea5e9' }}>
                            <span style={{ fontSize: '15px', fontWeight: '900', color: '#0369a1' }}>Parked At: {data?.carParkedAt}</span>
                        </div>
                    </div>

                    <Divider />

                    <h4 style={{ fontSize: '12px', color: '#747EEF', fontWeight: '800', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>BILLING SUMMARY</h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px' }}>
                            <span style={{ color: '#64748b' }}>Shop Price</span>
                            <span style={{ fontWeight: '700' }}>{data?.cost} AED</span>
                        </div>

                        {(data?.discount > 0 || promoCode) && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px', color: '#10b981', background: '#f0fdf4', padding: '12px', borderRadius: '14px' }}>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaTag /> Promo Discount Applied</span>
                                <span style={{ fontWeight: '900' }}>- {Number(data?.discount).toFixed(2)}  AED</span>
                            </div>
                        )}

                        <div style={{ borderTop: '2.5px solid #f1f5f9', marginTop: '10px', paddingTop: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontWeight: '900', fontSize: '18px', color: '#1e293b' }}>Total Final Amount</span>
                            <span style={{ fontSize: '28px', fontWeight: '950', color: '#10b981' }}>{data?.cost} AED</span>
                        </div>
                    </div>

                    <div style={{ marginTop: '25px', padding: '15px', background: '#1e293b', borderRadius: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#fff' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px' }}>
                            <FaCalendarAlt opacity={0.6} />{formatDateUTC(data?.date)} : {formatTimeInTimezone(data?.time)}
                        </div>
                        <div style={{ fontSize: '12px', fontWeight: '900', textTransform: 'uppercase', color: '#10b981' }}>{billingStatus}</div>
                    </div>

                    <button
                        onClick={() => setVisible(false)}
                        style={{ width: '100%', marginTop: '20px', padding: '16px', borderRadius: '18px', border: '1px solid #e2e8f0', background: '#fff', fontWeight: '900', color: '#1e293b', cursor: 'pointer', fontSize: '15px', ...generalSans }}
                    >
                        Close Details
                    </button>
                </div>
            </Dialog>
        </div>
    );
};

export default ActiveOrders;